export enum SessionFilesFolder {
  USER_FILES = 'user_files',
  OUTPUT = 'output'
}
